import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { BcAccountClientService } from '../../../service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';

export interface CommentModal {
	title: string;
	guid: string;
	numeroDocumento: string;
    linha: string;
    anoExercicio: string;
    empresa: string;
}

@Component({
	selector: 'comment-modal',
	templateUrl: './comment-modal.component.html',
	styleUrls: ['./comment-modal.component.scss'],
	providers: [ BcAccountClientService ]
})
export class CommentModalComponent extends DialogComponent<CommentModal, boolean> implements CommentModal {
	
	title: string;
	guid: string;
	numeroDocumento: string;
    linha: string;
    anoExercicio: string;
    empresa: string;

	public comments: any[] = [];

	public resultCount: number = 0;
	public orderby: string = "DataCriacao";
	public sort: string = "desc";
	currentPage: number = 0;

	constructor(dialogService: DialogService, private bcAccountClientService: BcAccountClientService, private flashMessagesService: FlashMessagesService) {
		super(dialogService);
	}

	ngOnInit() {
		this.getComments(0);
	}

	getComments(page) {
		this.bcAccountClientService.getComments(this.guid, this.orderby, this.sort, this.currentPage).subscribe(result => {
            if (result.Success) {
				//this.comments = result.Result;
				this.comments = result.Result.map(comment => {
                    if (comment.NumeroDocumento == this.numeroDocumento && comment.Linha == this.linha && comment.AnoExercicio == this.anoExercicio && comment.Empresa.trim() == this.empresa.trim())
                    {
                        return { ...comment, "Status": " ", classColor: " badge badge-success" };
                    } else {
                        return { ...comment, "Status": " ", classColor: " badge badge-info" };
                      }
                });

				this.resultCount = result.Count;
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.getComments(this.currentPage);
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.getComments($event);
	}

	confirm() {
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-billing-list/bc-billing-list-integral/comment-modal/comment-modal.component.ts